import Keycloak from 'keycloak-js'

export const keycloak = new Keycloak({
  // Deployed, meat proxies Keycloak on the same origin. Under the dev server
  // the app is on :3000, so go to Keycloak's port directly.
  url: DEV ? 'http://localhost:8180/auth' : `${location.origin}/auth`,
  realm: 'topian',
  clientId: 'meat-web',
})

/**
 * Sends the browser to Keycloak's login page unless there's already a session,
 * resolving once there is one.
 */
export async function login(): Promise<void> {
  await keycloak.init({
    onLoad: 'login-required',
    // Keep the login's code and state out of the hash, where the app's routes
    // live, so #/rooms/{slug} survives the round trip.
    responseMode: 'query',
  })
  // Refresh as the token runs out, so long meetings stay logged in.
  keycloak.onTokenExpired = () => {
    keycloak.updateToken().catch(() => keycloak.login())
  }
}

/**
 * The logged-in user's full name, or their username if they haven't set one;
 * undefined when not logged in. The server takes the same name from the token.
 */
export function userName(): string | undefined {
  const token = keycloak.tokenParsed
  return token?.name || token?.preferred_username
}
